import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Dropzone from './Dropzone';
import Swal from 'sweetalert2';

export const ModalBulkLoad = ({
  action,
  setPressedButton,
  project,
  userName,
  setRefresh,
}) => {
  const [selectedButton, setSelectedButton] = useState("ROP");

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  const handleInfoButtonClick = () => {
    Swal.fire({
      title: 'Instrucciones para Subir Archivos',
      html:
        '<p>A continuación, se detallan los métodos para cargar el archivo:</p>' +
        '<ol style="text-align: justify;">' +
        '  <li><strong>Actualizar SKU basado en el inventario:</strong> En caso de actualización, el inventario cambiará al valor ingresado, mientras que el ROP se mantendrá constante.</li>' +
        '  <li><strong>Insertar SKU basado en el ROP:</strong> En una inserción, el inventario será establecido en 0 y el ROP tomará el valor ingresado.</li>' +
        '  <li><strong>Actualizar SKU basado en el ROP:</strong> En caso de actualización, el ROP será modificado según el valor ingresado, y el inventario permanecerá igual.</li>' +
        '</ol>' +
        '<p><span style="color: red;">Nota:</span> Evita ingresar 0 en la cantidad, ya que esto impedirá la inserción del SKU.</p>',
      icon: 'info',
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#146284',
      footer: '¡Agradecemos tu colaboración al seguir estos procedimientos para asegurar una carga exitosa!'
    });
  };  

  return (
    <div className="modal-content">
      <style>
      {`
          .modal-content {
            background-color: #ffffff;
            border-radius: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
          }
          
          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #e5e5e5;
          }
          
          .modal-title {
            flex: 1;
            text-align: left;
            font-family: sans-serif;
            font-size: 20px;
            font-weight: bold;
            color: #333333;
          }
          
          .btn-close {
            margin-left: auto;
            font-size: 14px;
            color: #ffffff;
            border: none;
            border-radius: 50%;
          }
          
          .btn-group {
            display: flex;
            justify-content: space-between;
            width: 95%;
            margin-bottom: 15px;
            margin-left: 2.5%;
            margin-top: 2.5%;
          }
          
          .btn-primary {
            background-color: #007bff;
            color: #ffffff;
            border: none;
            border-radius: 5px;
          }
          
          .custom-button {
            background-color: #146284;
          }          
          
          .btn-secondary {
            background-color: #e5e5e5;
            color: #333333;
            border: none;
            border-radius: 5px;
          }
          
          .modal-body {
            padding: 15px;
          }
          
          .modal-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            border-top: 1px solid #e5e5e5;
          }

          .modal-footer .btn-info {
            background-color: #007bff;
            color: #ffffff;
          }
          
          .modal-footer .btn-info .fas.fa-info-circle {
            color: #ffffff;
          }
      `}
      </style>
      <div className="modal-header">
        <h5 className="modal-title">Crear SKUS de manera masiva</h5>
        <button
          type="button"
          className="btn-close ms-auto"
          onClick={() => setPressedButton("closeModal")}
          style={{ color: "#fff", fontSize: "12px" }}
        ></button>
      </div>
      <div className="btn-group">
        <Button
          variant={selectedButton === "ROP" ? "primary" : "secondary"}
          onClick={() => handleButtonClick("ROP")}
        >
          ROP
        </Button>
        <Button
          variant={selectedButton === "Inventario" ? "primary" : "secondary"}
          onClick={() => handleButtonClick("Inventario")}
        >
          Inventario
        </Button>
      </div>
      <div className="modal-body">
        <Dropzone
          project={project}
          userName={userName}
          setPressedButton={setPressedButton}
          setRefresh={setRefresh}
          selectedButton={selectedButton}
        />
      </div>
      <div className="modal-footer">
        <Button
          variant="primary"
          onClick={() => {
            window.open("/files/Plantilla-SKUS.xlsx", "_blank");
          }}
        >
          <i className="fas fa-file"></i> Descargar Plantilla
        </Button>
        <Button variant="info" onClick={handleInfoButtonClick}>
          <i className="fas fa-info-circle"></i> Información
        </Button>
      </div>
    </div>
  );
};